export default {"src":"/_next/static/media/fb-blu.94b3bb6d.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};